import React from 'react';
import {Box, Heading, HStack, VStack, Center, Divider} from 'native-base';
import {BolivarIcon, DollarIcon} from './../icons';
import {message} from './../../utils/messages';

interface Props {
  localBalance?: string;
  foreignBalance?: string;
  label?: string;
  showAuxLabel?: boolean;
  summary?: string;
}

const BalanceItem = (props: Props) => {
  const {localBalance, foreignBalance, label, showAuxLabel, summary} = props;

  const color = '#06355E';
  const colorDivider = '#9dd1ff';

  const checkShowAuxLabel = () => {
    if (showAuxLabel != null) {
      return showAuxLabel;
    }
    return true;
  };

  const getSummary = () => {
    if (summary != null) {
      return summary;
    }
    return 'balance-item-label-current';
  };

  return (
    <Box paddingBottom={2}>
      <HStack width="100%">
        <Heading color={'#858597'} width="50%" fontSize="md">
          {message(getSummary())}
        </Heading>
        <HStack width="50%" justifyContent="flex-end">
          <VStack justifyContent="center" space="0">
            <Box height="6" justifyContent="center">
              <DollarIcon />
            </Box>
            <Box height="9" justifyContent="center">
              <BolivarIcon />
            </Box>
          </VStack>
          <VStack minWidth="30%" justifyContent="flex-end">
            <Box height="8" justifyContent="center" paddingLeft="2">
              <Heading color={color} textAlign="right" fontSize="19">
                {foreignBalance ?? '-'}
              </Heading>
            </Box>
            <Box height="8" justifyContent="center" paddingLeft="2">
              <Heading color={color} textAlign="right" fontSize="19">
                {localBalance ?? '-'}
              </Heading>
            </Box>
          </VStack>
        </HStack>
      </HStack>
      {checkShowAuxLabel() && (
        <>
          <Divider
            thickness="1"
            bg={colorDivider}
            marginTop={4}
            marginBottom={4}
          />
          <Center marginBottom="2">
            <Heading color={'#0088FF'} fontSize={'md'}>
              {message(label ?? '')}
            </Heading>
          </Center>
        </>
      )}
    </Box>
  );
};

export default BalanceItem;
